var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 24.998C19.4036 24.998 25 19.4016 25 12.498C25 5.59449 19.4036 -0.00195312 12.5 -0.00195312C5.59644 -0.00195312 0 5.59449 0 12.498C0 19.4016 5.59644 24.998 12.5 24.998Z",
    fill: "#007AB9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9685 13.5046V18.6581H16.9806V13.85C16.9806 12.6427 16.5492 11.8182 15.4674 11.8182C14.6419 11.8182 14.1514 12.3733 13.9348 12.9107C13.8562 13.1028 13.8359 13.3695 13.8359 13.6389V18.6578H10.8478C10.8478 18.6578 10.8879 10.5145 10.8478 9.67155H13.8361V10.945C13.8301 10.955 13.8216 10.9648 13.8163 10.9744H13.8361V10.945C14.2332 10.334 14.9413 9.46054 16.529 9.46054C18.4947 9.46054 19.9685 10.7449 19.9685 13.5046ZM7.72204 5.33984C6.69995 5.33984 6.03125 6.01077 6.03125 6.89226C6.03125 7.75504 6.68056 8.44535 7.68282 8.44535H7.70221C8.74436 8.44535 9.39233 7.75504 9.39233 6.89226C9.3725 6.01077 8.74436 5.33984 7.72204 5.33984ZM6.20884 18.6581H9.1958V9.67155H6.20884V18.6581Z",
    fill: "#F1F2F2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.222537c8f50984ffe983d6549bd215db.svg";
export { ForwardRef as ReactComponent };